function FormsService(apiService) {
  this.getRequiredFields = function() {
    return apiService.get('/msi/merchant/required_fields', { cache: true });
  };
}

FormsService.$inject = ['apiService'];

module.exports = FormsService;
